import Util from '../../../../../../forecast-app/shared/util/util';
import moment from 'moment';

const CANVAS = document.createElement('canvas');

/**
 * This method returns an array. Each item in the array represents each day of the project (from start day to end day)
 * If the dayData matches the date currently looped through, its value will be used, otherwise 0
 */
function getChartDataByDay({project, dayData = [], onlyLabels = false, projection}) {
	const {projectFirstDateYear, projectFirstDateMonth, projectFirstDateDay, projectLastDateYear, projectLastDateMonth, projectLastDateDay} = project;

	const projectFirstDate = Util.CreateNonUtcMomentDate(projectFirstDateYear, projectFirstDateMonth, projectFirstDateDay);
	const projectLastDate = Util.CreateNonUtcMomentDate(projectLastDateYear, projectLastDateMonth, projectLastDateDay);

	if (!projectFirstDate || !projectLastDate) return [];

	const labels = [];
	const data = [];

	let currentDate = Util.CreateNonUtcMomentDate(projectFirstDateYear, projectFirstDateMonth, projectFirstDateDay);
	let today = moment();
	const projectionNotSpecified = projection === undefined;

	while (projectLastDate.diff(currentDate, 'days', true) >= 0) {
		const formattedCurrentDate = currentDate.clone().format('YYYY-MM-DD');

		if (!onlyLabels) {
			// If projection is undefined, fill the array normally
			if (projectionNotSpecified) {
				const dayExists = dayData.find(day => day.date === formattedCurrentDate);
				data.push(dayExists ? dayExists.value : 0);
			} else {
				// If projection is set to true, fill the array from today until the end of the project
				// Everything before today should be set to null
				if (projection) {
					if (currentDate.isBefore(today.clone().subtract(1, 'days'))) {
						data.push(null);
					} else {
						const dayExists = dayData.find(day => day.date === formattedCurrentDate);
						data.push(dayExists ? dayExists.value : 0);
					}
				} else {
					// If projection is set to false, fill the array froom the start of the project until today
					// Everything after today should be set to null
					if (currentDate.isAfter(today)) {
						data.push(null);
					} else {
						const dayExists = dayData.find(day => day.date === formattedCurrentDate);
						data.push(dayExists ? dayExists.value : 0);
					}
				}
			}
		} else {
			labels.push(currentDate.toDate());
		}

		currentDate = currentDate.add(1, 'days');
	}

	return onlyLabels ? labels : data;
}

function getGradients() {
	const ctx = CANVAS.getContext('2d');
	const fillGradient = [0.0, 500.0, 0.0, 0.0];

	const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);

	gradientStroke.addColorStop(0, 'rgba(127, 229, 178)');
	gradientStroke.addColorStop(1, 'rgb(127, 229, 178)');

	const gradientFill = ctx.createLinearGradient(...fillGradient);

	gradientFill.addColorStop(0, 'rgba(217, 248, 232, 0.2)');
	gradientFill.addColorStop(1, 'rgba(217, 248, 232, 1)');

	const gradientStrokeActual = ctx.createLinearGradient(500, 0, 100, 0);

	gradientStrokeActual.addColorStop(0, 'rgb(173, 227, 255)');
	gradientStrokeActual.addColorStop(1, 'rgb(173, 227, 255)');

	const gradientFillActual = ctx.createLinearGradient(...fillGradient);

	gradientFillActual.addColorStop(1, 'rgba(234, 248, 255, 0.6)');
	gradientFillActual.addColorStop(1, 'rgba(234, 248, 255, 1)');

	const invoicedGradientFill = ctx.createLinearGradient(...fillGradient);

	invoicedGradientFill.addColorStop(0, 'rgba(253, 248, 209, 0.4)');
	invoicedGradientFill.addColorStop(1, 'rgba(253, 248, 209, 1)');

	const paidGradientFill = ctx.createLinearGradient(...fillGradient);

	paidGradientFill.addColorStop(0, 'rgba(255, 243, 251, 0.6)');
	paidGradientFill.addColorStop(1, 'rgba(255, 243, 251, 1)');

	const gradientStrokeFixedPrice = ctx.createLinearGradient(500, 0, 100, 0);
	gradientStrokeFixedPrice.addColorStop(0, 'rgba(154,208,255, 1)');
	gradientStrokeFixedPrice.addColorStop(1, 'rgba(154,208,255, 1)');

	const gradientFillFixedPrice = ctx.createLinearGradient(...fillGradient);
	gradientFillFixedPrice.addColorStop(0, 'rgba(154,208,255, 0.2)');
	gradientFillFixedPrice.addColorStop(1, 'rgba(154,208,255, 0)');

	const gradientStrokeBaseline = ctx.createLinearGradient(500, 0, 100, 0);
	gradientStrokeBaseline.addColorStop(0, 'rgba(47,97,213, 1)');
	gradientStrokeBaseline.addColorStop(1, 'rgba(47,97,213, 1)');

	return {gradientStroke, gradientFill, gradientStrokeActual, gradientFillActual, invoicedGradientFill, paidGradientFill, gradientStrokeFixedPrice, gradientFillFixedPrice, gradientStrokeBaseline};
}

function getDifference(a, b) {
	const data = [];

	for (let i = 0; i < a.length; i++) {
		data.push(a[i] - b[i]);
	}

	return data;
}

function getSum(a, b) {
	const data = [];

	for (let i = 0; i < a.length; i++) {
		if (a[i] === null && b[i] === null) {
			data.push(null);
			continue;
		}
		data.push(a[i] + b[i]);
	}

	return data;
}

function getAccumulation(array, startFrom) {
	let total = startFrom || 0;
	const data = [];
	for (let i = 0; i < array.length; i++) {
		total += array[i];

		data.push(array[i] === null ? null : total);
	}

	return data;
}

module.exports = {
	getDifference,
	getSum,
	getAccumulation,
	getChartDataByDay,
	getGradients,
};
